import * as actionTypes from '../actions/actionTypes';

const initialState = {
  emailConfigs: {
    emailConfigs: [],
    count: "",
    isLoading: false,
    isError: false
  },
  createEmailConfigData: {},
  isLoading: false,
  isError: false,
  editEmailConfig: {},
  editEmailConfigData: {},
  deleteEmailConfigData: {
    isLoading: false,
    isError: false,
    data: {}
  }  
}

const emailConfigReducer = (state = initialState, action = {}) => {

  const newState = { ...state };

  switch (action.type) {
    case actionTypes.FETCH_EMAIL_CONFIG_LIST:
      return { ...newState, emailConfigs: { ...newState.emailConfigs, isLoading: true } };

    case actionTypes.FETCH_EMAIL_CONFIG_LIST_SUCCESS:
      return { ...newState, emailConfigs: { emailConfigs: [...action.payload], count: action.payload.totalCount, isLoading: false, isError: false } };

    case actionTypes.FETCH_EMAIL_CONFIG_LIST_FAILURE:
      return { isLoading: false, isError: true };

    case actionTypes.CREATE_EMAIL_CONFIG:
      return { ...newState, isLoading: true, createEmailConfigData: {} };

    case actionTypes.CREATE_EMAIL_CONFIG_SUCCESS:
      return { ...newState, isLoading: false, createEmailConfigData: { ...action.payload } };

    case actionTypes.CREATE_EMAIL_CONFIG_FAILURE:
      return { ...newState, isLoading: false, isError: true, createEmailConfigData: { ...action.payload } };
    
    case actionTypes.RESET_CREATE_EMAIL_CONFIG_STATE:
      return { ...newState, isLoading: false, createEmailConfigData: {} };

    case actionTypes.FETCH_EMAIL_CONFIG_DETAIL:
      return { ...newState, isLoading: true, isError: false, editEmailConfig: {} };

    case actionTypes.FETCH_EMAIL_CONFIG_DETAIL_SUCCESS:
      return { ...newState, isLoading: true, isError: false, editEmailConfig: {...action.payload} };
    
    case actionTypes.FETCH_EMAIL_CONFIG_DETAIL_FAILURE:
      return { ...newState, isLoading: true, isError: true, editEmailConfig: {...action.payload} };

    case actionTypes.RESET_EDIT_EMAIL_CONFIG_STATE:
      return { ...newState, isLoading: false, editEmailConfigData: {} };

    case actionTypes.EDIT_EMAIL_CONFIG:
      return { ...newState, isLoading: true };

    case actionTypes.EDIT_EMAIL_CONFIG_SUCCESS:
      return { ...newState, isLoading: false, editEmailConfigData: { ...action.payload } };

    case actionTypes.EDIT_EMAIL_CONFIG_FAILURE:
      return { ...newState, isLoading: false, isError: true, editEmailConfigData: { ...action.payload } };

    case actionTypes.DELETE_EMAIL_CONFIG:
      return { ...newState, deleteEmailConfigData: { isLoading: true } };

    case actionTypes.DELETE_EMAIL_CONFIG_SUCCESS:
      return { ...newState, deleteEmailConfigData: { isLoading: false, data: { ...action.payload } } };

    case actionTypes.DELETE_EMAIL_CONFIG_FAILURE:
      return { ...newState, deleteEmailConfigData: { isLoading: false, data: { ...action.payload } } };

    default:
      return { ...newState };
  }
};


export default emailConfigReducer;